import { StatusAlert } from '@energy-retailer/icons';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Icon } from '@/components/icon';
import { Text } from '@/components/text';

import type { AlertBoxProps } from './alert.types';

const AlertBox = ({
  icon,
  children,
  title,
  buttonComponent,
  className,
}: AlertBoxProps) => {
  return (
    <div
      className={twMerge(
        clsx(
          'flex w-full flex-col items-center gap-b rounded-rad-a border border-pink p-d lg:px-b lg:py-c',
          className
        )
      )}
      role="alert"
    >
      <div>
        <Icon
          className="h-icon-md w-icon-md text-pink"
          icon={icon ? icon : <StatusAlert data-testid="status icon" />}
        />
      </div>
      <Text
        as="h3"
        variant="h2"
      >
        {title}
      </Text>
      <div className="mx-auto text-center lg:w-3/4">{children}</div>
      {buttonComponent ? <div>{buttonComponent}</div> : null}
    </div>
  );
};

export default AlertBox;
